export default {
	props: {
		field: String,
		dataItem: Object,
		format: String,
		className: String,
		columnIndex: Number,
		columnsCount: Number,
		rowType: String,
		level: Number,
		expanded: Boolean,
		editor: String,

		isInEditMode: false,
		readonly: { type: Boolean, default: false },
		required: { type: Boolean, default: true }
	},

	data: function() {
		return {
			show: false,
			filterText: "",
			buttoncolorPickerText: {
				apply: "Applica",
				cancel: "Annulla"
			},

			imageUrl: "../../../assets/upload.png",
			imageMapUrl: "../../../assets/pin_standar_map.png",
			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd/MM/yyyy') #"
		};
	},

	methods: {
		getNestedValue(fieldName, dataItem) {
			const path = fieldName.split(".");
			let data = dataItem;
			path.forEach(p => {
				data = data ? data[p] : undefined;
			});

			if (data && this.format == "numeric") {
				data = kendo.toString(data, "n2");
				data = data.replace(".", ",");
			}
			else if(data && this.format == "numeric-int") {
				data = kendo.toString(data, "n0");
				data = data.replace(".", ",");
			}
			return data;
		},

		pickFile() {
			if (this.isInEditMode) {
				this.$refs.image.click();
				this.$emit("remove-all-edit-cell", this);
			}
		},

		onFilePicked(e) {
			var self = this;
			const files = e.target.files;
			if (files[0] !== undefined) {
				var imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					self.dataItem[self.field] = fr.result;
					self.$emit("cell-item-change", self);
					//self.imageFile = files[0]; // this is an image file that can be sent to server...
				});
			}
		},

		clickHandler: function() {
			if (this.format != "image" && this.format != "booleanSwitch") this.$emit("cell-click", this);
		},
		itemChange: function(e) {
			if (this.format == "color") {
				this.dataItem[this.field] = e.value;
			}

			this.$emit("cell-item-change", this);
		},
		booleanSwitchChange: function(e) {
			this.dataItem[this.field] = !this.dataItem[this.field];
			this.$emit("boolean-switch-change", this);
		}
	},
	computed: {
		emptyCell() {
			if (
				this.isInEditMode &&
				this.format != "image" &&
				this.format != "color" &&
				(this._.isNull(this.dataItem[this.field]) || this._.isUndefined(this.dataItem[this.field]) || this.dataItem[this.field] === "") &&
				this.required
			)
				return "cell-danger";
			else return "";
		},
		imageToShow() {
			if (this.isInEditMode == false && !this.dataItem[this.field]) return "";
			if (this.dataItem[this.field]) {
				return this.dataItem[this.field];
			}

			return this.imageUrl;
		},
		imageMapToShow() {
			if (this.isInEditMode == false && !this.dataItem[this.field]) return "";
			if (this.dataItem[this.field]) {
				return this.dataItem[this.field];
			}

			return this.imageMapUrl;
		},
		colorToShow() {
			if (this.dataItem[this.field]) {
				return this.dataItem[this.field];
			}

			return null;
		}
	}
};
